const color = {
  primary: '#206675',
  primary2: '#FFFFFF',
  primary3: '#206675',
  success: '',
  text: '#333333',
  error: '#ff0000',
  warning: '#ffb600',
  placeholder: '#000000',
  shadow: 'rgba(75,77,82,0.5)',
  background: '#CBFAFF',

  // Hover
  primaryHover: '#FC7A1E',
  primary2Hover: '#FC7A1E',
  primary3Hover: '#FC7A1E',
  errorHover: '#be0000',
  warningHover: '#be0000',

  // wireframe
  grey: '#4f4e4e',
  white: '#FFFFFF',
  black: '#000000',
  hover: '#707070',
}

export default color
